import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../config";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faSave, faArrowLeft,faSpinner } from "@fortawesome/free-solid-svg-icons";
import { RateLimitAlertContext } from "../../contexts/RateLimitAlertContext";
import { AdminAccessAlertContext } from "../../contexts/AdminAccessAlertContext";
import Vardump from "./Vardump";


const CorporateSetup = () => {
  const { corp_code } = useParams();
  const navigate = useNavigate();
  const [corpPrefix, setCorpPrefix] = useState("");
  const [actualCorpName, setActualCorpName] = useState("");
  const [corpData, setCorpdata] = useState(null);
  const [prefixes, setPrefixes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPrefixes, setLoadingPrefixes] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [saving, setSaving] = useState(false);
  const { openAlert: openRateLimitAlert } = React.useContext(RateLimitAlertContext);
  const { openAlert: openAdminAccessAlert } = React.useContext(AdminAccessAlertContext);

  useEffect(() => {
    fetchPrefixes();
    fetchCorporateData();
  }, [corp_code]);

  const fetchPrefixes = async () => {
    setLoadingPrefixes(true);
    try {
      const response = await axios.get(`${BASE_URL}/corporate/prefixes/data`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
        },
      });
      setPrefixes(response.data.prefixes || []);
      console.log(response.data.prefixes)
    } catch (error) {
      if (error.response?.status === 401) window.location.href = "/login";
      if (error.response?.status === 403) openAdminAccessAlert();
      if (error.response?.status === 429) openRateLimitAlert();
      Swal.fire("Error!", "Failed to fetch corporate prefixes.", "error");
    } finally {
      setLoadingPrefixes(false);
    }
  };

  const fetchCorporateData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/corporate/${corp_code}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
        },
      });
      const data = response.data.data;
      setCorpPrefix(data.corpPrefix || "");
      setActualCorpName(data.actualCorpName || "");
      setCorpdata(data);
    } catch (error) {
      if (error.response?.status === 401) window.location.href = "/login";
      if (error.response?.status === 403) openAdminAccessAlert();
      if (error.response?.status === 429) openRateLimitAlert();
      Swal.fire("Error!", "Failed to fetch corporate data.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!corpPrefix.trim()) {
      Swal.fire("Error!", "Corp Prefix is required.", "error");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to update the corporate prefix and actual name!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#ef4444",
      confirmButtonText: "Yes, update it!",
    });

    if (result.isConfirmed) {
      setSaving(true);
      setLoadingSave(true);
      try {
        await axios.put(
          `${BASE_URL}/corporate/update-corp-prefix/${corp_code}`,
          {
            corp_prefix: corpPrefix.trim(),
            actual_corp_name: actualCorpName.trim() || null,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
            },
          }
        );
        Swal.fire("Success!", "Corporate details updated successfully.", "success");
        // Optionally refresh or navigate back
        // navigate(`/corporate-settings`); // or stay and refetch
        fetchCorporateData(); // Refetch to confirm
      } catch (error) {
        if (error.response?.status === 401) window.location.href = "/login";
        if (error.response?.status === 403) openAdminAccessAlert();
        if (error.response?.status === 429) openRateLimitAlert();
        Swal.fire("Error!", "Failed to update corporate details.", "error");
      } finally {
        setLoadingSave(false);
        setSaving(false);
      }
    }
  };

  const handleBack = () => {
    navigate("/corporate-settings"); // Assuming back to the table
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 p-4 sm:p-6 font-sans">
        <div className="max-w-md mx-auto">
          <div className="animate-pulse bg-white rounded-xl shadow-sm p-6">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2 mb-6"></div>
            <div className="space-y-4">
              <div className="h-10 bg-gray-200 rounded"></div>
              <div className="h-10 bg-gray-200 rounded"></div>
              <div className="h-10 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 font-sans">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="mb-6 flex items-center gap-3">
          <button
            onClick={handleBack}
            className="p-2 bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="text-gray-600" />
          </button>
          <div className="p-2 bg-white rounded-lg shadow-sm">
            <FontAwesomeIcon icon={faCog} className="text-blue-600" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-gray-900">Corporate Setup</h1>
            <p className="text-xs text-gray-500">Update prefix and actual name for {corp_code}</p>
           
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSave} className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="p-6 space-y-6">
             
            {/* Corp Prefix Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Corp Prefix <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="text"
                  list="prefixDatalist"
                  value={corpPrefix}
                  onChange={(e) => setCorpPrefix(e.target.value)}
                  placeholder="Select existing or enter new Corp Prefix"
                  className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors"
                  required
                  disabled={saving}
                />
                {loadingPrefixes ? (
                  <div className="absolute right-3 top-1/2 -translate-y-1/2">
                    <FontAwesomeIcon icon={faSpinner} className="animate-spin text-gray-400" />
                  </div>
                ) : null}
              </div>
              <datalist id="prefixDatalist">
                {prefixes.map((prefix) => (
                  <option key={prefix.corp_prefix} value={prefix.corp_prefix} />
                ))}
              </datalist>
              <p className="mt-1 text-xs text-gray-500">
                Type to search existing prefixes or enter a new one.
              </p>
            </div>

            {/* Actual Corp Name Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Actual Corporate Name
              </label>
              <input
                type="text"
                value={actualCorpName}
                onChange={(e) => setActualCorpName(e.target.value)}
                placeholder="Enter actual corporate name"
                className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors"
                disabled={saving}
                maxLength={255}
              />
            </div>
          </div>

          {/* Actions */}
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end gap-3">
            <button
              type="button"
              onClick={handleBack}
              className="px-4 py-2 text-sm text-gray-700 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors"
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving || loadingSave}
              className="flex items-center gap-2 px-4 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faSave} />
              {loadingSave ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
        <Vardump data={corpData} title="Corp Data" />
      </div>
    </div>
  );
};

export default CorporateSetup;